import { ProductCatalogApiClient } from '@fourthwall/services/dist/ProductCatalogApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const usePersonalizedRecommendationsQuery = createQueryHook(
  ProductCatalogApiClient.getPersonalizedRecommendations,
  { queryKey: ['personalizedRecommendations'] },
)
